module.exports = __webpack_public_path__ + "img/lowhighalarm_tankreservoir.482d7612.svg";